import styled from "styled-components";
import { ReactComponent as AddWhite } from "../../../assets/img/icons/addWhite.svg";
type Props = {
  className?: string;
  setShowNewListAsider?: (arg0: boolean) => void;
  onClick?: any;
};
const AddCampaign: React.FC<Props> = ({ className, setShowNewListAsider, onClick }) => {
  const handleOnClick = () => {
    if (onClick) {
      onClick();
    } else if (setShowNewListAsider) {
      setShowNewListAsider(true);
    }
  };
  return (
    <Wrapper className={`${className === undefined ? "" : className}`}>
      <span onClick={handleOnClick} data-id="qa-add-compaign">
        <AddWhite />
      </span>
    </Wrapper>
  );
};

export default AddCampaign;

const Wrapper = styled.div`
  height: calc(100% - 50px);
  width: 100%;
  // margin-bottom: 50px;
  position: relative;
  &.list-add-view {
    height: 100px;
    width: 100px;
  }
  span {
    background-color: rgb(126, 126, 126);
    padding: 12px;
    opacity: 0.5;
    border-radius: 8px;
    cursor: pointer;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 6px;
    }
    svg {
      float: left;
      height: 30px;
      width: 30px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 20px;
        width: 20px;
      }
    }
  }
`;
